export default {
    unsubscribed_contacts_main_title: 'Unsubscribed Contacts',
    unsubscribed_contacts_main_add_unsubscribed_contact: 'Add Unsubscribed Contact',
    unsubscribed_contacts_main_id: 'Id',
    unsubscribed_contacts_main_to: 'To',
    unsubscribed_contacts_main_via: 'Via',
    unsubscribed_contacts_main_source: 'Source',
    unsubscribed_contacts_main_reason: 'Reason',
    unsubscribed_contacts_main_30: 'Spam Detected',
    unsubscribed_contacts_main_50: 'Invalid Destination Number',
    unsubscribed_contacts_main_70: 'Destination Permanently Unavailable',
    unsubscribed_contacts_main_100: 'Prohibited by Carrier',
    unsubscribed_contacts_main_200: 'Source Number Blocked by STOP from Destination Number',
    unsubscribed_contacts_main_details: 'Details',
    unsubscribed_contacts_main_created_on: 'Created On',
    unsubscribed_contacts_main_created_by: 'Created By',
    unsubscribed_contacts_main_via_sms: 'SMS',
    unsubscribed_contacts_main_via_email: 'Email',
};
